import { useQuery } from 'react-query';

import { SoilProfile } from './../types/types';
import LandscanService from './landscanService';

export const useGetProfileCsv = (soilProfile: SoilProfile | null) => {
  try {
    return useQuery<string>(
      ['profile-csv', soilProfile?.soilprofileId], 
      () => LandscanService.getTextCsv(soilProfile && soilProfile.maskedCsvUrl ? soilProfile.maskedCsvUrl : "")
    );
  } catch(e) {
      console.error("Error: couldn't get maskedCsvUrl data", e);
      return {data:null,isLoading:false};
  }
}

